//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    name: 'activity-Html-Detail',
    components: {
        VueUeditorWrap
    },
    data() {
        return {
            showContentModel: false,
            id: 0,
            finance: {
                content: ''
            },
            editorConfig: {
                UEDITOR_HOME_URL: '/UEditor/'
            },
            ueditor: null,
            content: {},
            classObject: {
                display: 'none'
            },
        };
    },
    methods: {
        getActivityContent() {
            abp.ajax.get('/api/services/app/Activity/GetActivityContent?id=' + this.id).then((res) => {
                this.content = {};
                this.content = res.data.result;
            }).finally(() => {
                // vm.saving = false;
            });
        },
        onSaveActivityContent() {
            var vm = this;
            var params = {
                activityId: this.id,
                content: vm.finance.content
            };
            vm.saving = true;
            vm.$store.dispatch({
                type: 'activity/saveActivityContent',
                data: params
            }).then(() => {
                vm.$Notice.success({
                    duration: 3,
                    title: '保存成功'
                });
                vm.showContentModel = false;
                vm.getActivityContent();
            }).finally(() => {
                vm.saving = false;
            });
        },
        fEditorReady(editor) {
            this.ueditor = editor;
            this.finance = {
                content: this.content.content != null ? this.content.content : ''
            };
        },
        showContentEdit() {
            this.showContentModel = true;
            var vm = this;
            vm.finance.content = vm.content.content;
        },
        closeContentEdit() {
            this.showContentModel = false;
        },
        onSaveContent() {
            this.showContentModel = false;
            this.onSaveActivityContent();
        },
    },
    created() {
        this.id = this.$route.params.id;
        this.getActivityContent();
    }
};
